module.exports = __webpack_public_path__ + "static/media/LB.2d0a2619.png";